<template>
    <div>
        <PageHeader :title="pageTitle">
            <template v-slot:icon>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="page-header-icon">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M3 8.25V18a2.25 2.25 0 0 0 2.25 2.25h13.5A2.25 2.25 0 0 0 21 18V8.25m-18 0V6a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 6v2.25m-18 0h18M5.25 6h.008v.008H5.25V6ZM7.5 6h.008v.008H7.5V6Zm2.25 0h.008v.008H9.75V6Z" />
                </svg>
            </template>
        </PageHeader>

        <div class="grid grid-cols-6 gap-4 min-h-screen">
            <!-- LISTA DE FORMS -->
			<div class="col-span-2 border border-green-500 p-4">
				<div class="flex flex-col gap-y-4">
					<div class="flex items-center justify-between gap-2">
						<h1 class="text-lg font-semibold text-green-600">Todos os formulários</h1>
						<BaseButton @click="createForm()" skin="primary">Criar Novo</BaseButton>
					</div>
					<div class="grid grid-cols-1 gap-2 md:grid-cols-2">
						<BaseSelect
							class="w-full"
							:options="filterTypeOptions"
							label="Tipo"
							v-model="filterType"
						/>
						<BaseInput
							class="w-full"
							label="Buscar por nome"
							placeholder="Digite para filtrar"
							v-model="filterName"
						/>
					</div>
				</div>

				<!-- Loading Skeleton-->
                <div v-if="loadingFormList" class="mt-4 mx-auto w-full rounded-md p-4">
                    <div class="flex animate-pulse space-x-4">
                        <div class="size-10 rounded-full bg-gray-300"></div>
                        <div class="flex-1 space-y-6 py-1">
                        <div class="h-2 rounded bg-gray-300"></div>
                        <div class="space-y-3">
                            <div class="grid grid-cols-3 gap-4">
                            <div class="col-span-2 h-2 rounded bg-gray-300"></div>
                            <div class="col-span-1 h-2 rounded bg-gray-300"></div>
                            </div>
                            <div class="h-2 rounded bg-gray-300"></div>
                        </div>
                        </div>
                    </div>
                </div>

                <div v-if="!loadingFormList" class="flex flex-col mt-4">
                    <div
                    @click="selectForm(form)"
                    class="bg-white p-4 border border-green-400 cursor-pointer mt-4 hover:bg-green-50"
                    v-for="form in forms" :key="form.uuid"
                    :class="{ 'bg-green-600 hover:bg-green-600 text-white': form.uuid == selectedForm?.uuid }"
                    >
                        <div class="flex justify-end gap-x-2">
                            <button
                                type="button"
                                @click.stop="confirmDuplicateForm(form)"
                                class="rounded-full p-1.5 cursor-pointer text-current transition-colors duration-150 hover:bg-green-100 hover:text-green-600"
                            >
                                <svg class="w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 7.5V6.108c0-1.135.845-2.098 1.976-2.192.373-.03.748-.057 1.123-.08M15.75 18H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08M15.75 18.75v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5A3.375 3.375 0 0 0 6.375 7.5H5.25m11.9-3.664A2.251 2.251 0 0 0 15 2.25h-1.5a2.251 2.251 0 0 0-2.15 1.586m5.8 0c.065.21.1.433.1.664v.75h-6V4.5c0-.231.035-.454.1-.664M6.75 7.5H4.875c-.621 0-1.125.504-1.125 1.125v12c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V16.5a9 9 0 0 0-9-9Z" />
                                </svg>
                            </button>
                            <button
                                type="button"
                                @click.stop="destroyForm(form.uuid)"
                                class="rounded-full p-1.5 cursor-pointer text-current transition-colors duration-150 hover:bg-green-100 hover:text-green-600"
                            >
                                <svg class="w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
                                </svg>
                            </button>
                        </div>
                        <div class="flex flex-col mb-2">
                            <h1 :class="{ 'text-green-600': form.uuid !== (selectedForm && selectedForm?.uuid) }" class="text-base text-white font-semibold mb-1">{{ form.name.length > 40 ? form.name.slice(0, 40) + '...' : form.name }}</h1>
                            <span :class="{ 'text-gray-500': form.uuid !== (selectedForm && selectedForm?.uuid) }" class="text-xs text-white font-light">Criado em: {{ defaultDate(form.created_at) }}</span>
                            <span :class="{ 'text-gray-500': form.uuid !== (selectedForm && selectedForm?.uuid) }" class="text-xs text-white font-light">Atualizado em: {{ defaultDate(form.created_at) }}</span>
                        </div>
                        <Tag :text="form.type || form.form_body?.type" type="info" />
                    </div>
                </div>

                <Alert class="mt-4" text="Não existe Forms criados" :show="!forms.length && !loadingFormList" />
                <PaginationV2 v-if="!loadingFormList && forms.length" class="mt-12" :total="totalItens" v-model="page" :limit="limit" @changePage="changePagination" />
            </div>
            <div class="col-span-4 border border-green-500 p-4">

                <!-- Loading Skeleton-->
                <div v-if="loadingFormRender" class="mt-4 mx-auto w-full rounded-md p-4">
                    <div class="flex animate-pulse space-x-4">
                        <div class="size-10 rounded-full bg-gray-300"></div>
                        <div class="flex-1 space-y-6 py-1">
                        <div class="h-2 rounded bg-gray-300"></div>
                        <div class="space-y-3">
                            <div class="grid grid-cols-3 gap-4">
                            <div class="col-span-2 h-2 rounded bg-gray-300"></div>
                            <div class="col-span-1 h-2 rounded bg-gray-300"></div>
                            </div>
                            <div class="h-2 rounded bg-gray-300"></div>
                        </div>
                        </div>
                    </div>
                </div>

                <div v-if="!loadingFormRender">
                    <div class="flex gap-x-4 mt-4">
                        <BaseButton v-if="selectedForm?.uuid && form.type !== 'pdi'" @click="setFormForuse(form.uuid)" skin="primary">Usar Modelo</BaseButton>
                        <BaseButton v-if="selectedForm?.uuid" @click="preview(form.uuid)" skin="primary">Visualizar</BaseButton>
                    </div>

                    <!-- Configuração Geral do Form-->
                    <div v-if="form.uuid" class="flex flex-col gap-y-4 mt-4 p-4 bg-white rounded-md">
                        <h1 class="text-gray-600 font-bold text-xl">Configuração geral do formulário</h1>
                        <h1 class="text-xl font-semibold text-green-600">{{ form.name }}</h1>
                        <div class="flex gap-x-2">
                            <BaseInput class="flex-1" label="Nome do Form" v-model="form.name" />
                            <BaseSelect class="flex-1" :options="formTypeOptions" empty-option="--Selecione--" label="Tipo do Formulário" v-model="form.type" @change="onSelectFormType(form.type)" />
                        </div>
                    </div>

					<div class="bg-white p-4 mt-4" v-if="form.type === '360'">
                        <h1 class="text-gray-600 font-bold text-xl">Instruções</h1>
						<h2 class="text-gray-600 font-semibold text-sm mt-4">As perguntas que você colocar aqui serão multiplicadas automaticamente para todos os colaboradores envolvidos na pesquisa.</h2>
						<h2 class="text-green-600 font-semibold text-sm mt-4">A primeira pergunta é fixa para o tipo 360</h2>
					</div>

                    <!-- Configuração de Score/Resultados-->
                    <div class="bg-white p-4 mt-4" v-if="form.type === 'pdi'">
                        <h1 class="text-gray-600 font-bold text-xl">Configuração de Resultados</h1>
                        <div class="flex flex-col mt-2">
							<div class="flex flex-col mt-2">
								<h2 class="text-green-400 font-semibold uppercase">Resultado Excelente Quando:</h2>
								<div class="flex gap-x-4">
									<BaseInput v-maska="MaskService['numeric']" class="flex-1" label="Maior ou igual à" placeholder="Numero" v-model="form.score_result.excellent['>=']" />
								</div>
							</div>
                            <div class="flex flex-col mt-2">
                                <h2 class="text-green-600 font-semibold uppercase">Resultado Positivo Quando:</h2>
                                <div class="flex gap-x-4">
									<BaseInput v-maska="MaskService['numeric']" class="flex-1" label="Maior ou igual à" placeholder="Numero" v-model="form.score_result.positive['>=']" />
									<BaseInput v-maska="MaskService['numeric']" class="flex-1" label="Menor que (ex: valor de Excelente)" placeholder="Numero" v-model="form.score_result.positive['<']" />
								</div>
                            </div>
                            <div class="flex flex-col mt-2">
                                <h2 class="text-yellow-600 font-semibold uppercase">Resultado Neutro Quando:</h2>
                                <div class="flex gap-x-4">
                                    <BaseInput v-maska="MaskService['numeric']" class="flex-1" label="Maior ou igual à" placeholder="Numero" v-model="form.score_result.neutral['>=']" />
                                    <BaseInput v-maska="MaskService['numeric']" class="flex-1" label="Menor que" placeholder="Numero" v-model="form.score_result.neutral['<']" />
                                </div>
                            </div>
                            <div class="flex flex-col mt-2">
                                <h2 class="text-red-400 font-semibold uppercase">Resultado Negativo Quando:</h2>
                                <div class="flex gap-x-4">
                                    <!-- <BaseInput v-maska="MaskService['numeric']" class="flex-1" label="Maior que" placeholder="Numero" v-model="form.score_result.negative['>']" /> -->
                                    <BaseInput v-maska="MaskService['numeric']" class="flex-1" label="Menor que" placeholder="Numero" v-model="form.score_result.negative['<']" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="flex flex-col mt-4" v-if="form.uuid && form.type != ''">
                        <h1 class="text-gray-600 font-bold text-xl">Perguntas do Formulário</h1>
                        <div v-for="(field, index) in form.structure" :key="field.uuid" class="flex bg-white p-4 rounded-md mt-4">
                            <div class="flex flex-col flex-1">
                                <!-- Cabeçalho da Pergunta -->
                                <div class="flex items-center gap-2 mb-2">
                                    <!-- Botões de mover -->
                                    <div class="flex flex-col mr-8">
                                        <button @click="moveFieldUp(index)" :disabled="index === 0" class="disabled:opacity-30">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M19 15l-7-7-7 7" />
                                            </svg>
                                        </button>
                                        <button @click="moveFieldDown(index)" :disabled="index === form.structure.length - 1" class="disabled:opacity-30">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M5 9l7 7 7-7" />
                                            </svg>
                                        </button>
                                    </div>

									<h1 v-if="field.fixed && form.type === '360'" class="text-yellow-700 font-bold">Fixa (360)</h1>
									<h1 v-if="field.fixed && form.type === 'pdi'" class="text-yellow-700 font-bold">Fixa PDI</h1>
									<h1 v-if="field.fixed && form.type === 'event'" class="text-yellow-700 font-bold">Campo Fixo (Evento)</h1>
    
                                    <!-- Título da pergunta -->
                                    <div class="flex flex-col" v-if="!field.fixed">
                                        <h1 class="text-green-400 text-lg font-bold">Pergunta: {{ index + 1 }}</h1>
                                        <BaseCheckbox class="mt-1" label="Só a Megaluzz pode ver e responder" v-model="field.lock" />
                                        <BaseCheckbox v-if="form.type === 'pdi'" class="mt-1" label="Vínculo de presença" v-model="field.presence_sync" />
                                    </div>
                                    <div class="flex flex-col mt-8 ml-3.5">
                                        <BaseCheckbox :disabled="field.type === 'static_text'" label="Obrigatório" v-model="field.required" />
                                    </div>
									<div v-if="!field.fixed" class="flex items-center gap-x-2 mt-4 ml-8">
                                        <button
                                            type="button"
                                            @click="duplicateQuestion(index)"
                                            class="rounded-full p-1.5 cursor-pointer text-current transition-colors duration-150 hover:bg-green-100 hover:text-green-600"
                                        >
                                            <svg class="w-6 h-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 7.5V6.108c0-1.135.845-2.098 1.976-2.192.373-.03.748-.057 1.123-.08M15.75 18H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08M15.75 18.75v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5A3.375 3.375 0 0 0 6.375 7.5H5.25m11.9-3.664A2.251 2.251 0 0 0 15 2.25h-1.5a2.251 2.251 0 0 0-2.15 1.586m5.8 0c.065.21.1.433.1.664v.75h-6V4.5c0-.231.035-.454.1-.664M6.75 7.5H4.875c-.621 0-1.125.504-1.125 1.125v12c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V16.5a9 9 0 0 0-9-9Z" />
                                            </svg>
                                        </button>
                                        <button
                                            type="button"
                                            @click="deleteQuestion(field.uuid)"
                                            class="rounded-full p-1.5 cursor-pointer text-red-600 transition-colors duration-150 hover:bg-green-100 hover:text-green-600"
                                        >
                                            <svg class="w-6 h-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                                            </svg>
                                        </button>
									</div>
                                </div>
								
                                <div class="flex gap-x-2">
									<!-- TITULO DA PERGUNTA -->
									<h1 v-if="field.fixed && form.type === '360'" class="text-base text-gray-600 font-semibold w-8/12">{{ field.label }}</h1>
									<h1 v-if="field.fixed && form.type === 'pdi'" class="text-base text-gray-600 font-semibold w-8/12">{{ field.label }}</h1>
									<h1 v-if="field.fixed && form.type === 'event'" class="text-base text-gray-600 font-semibold w-8/12">{{ field.label }}</h1>
                                    <BaseInput v-if="!field.fixed" class="flex-1 mb-2" label="Título da Pergunta" placeholder="Título da Pergunta" v-model="field.label" maxlength="400" />
                                    <div class="flex flex-col">
										<BaseSelect class="flex-1" :disabled="field.fixed" :options="getAllowedFieldTypes(form.type)" default-value="text" label="Tipo do Campo" v-model="field.type" @change="onChangeFieldType(index, field.type)" />
                                    </div>
                                </div>
                                
								<BaseInput v-if="form.type === 'pdi' && field.type === 'multiple_choice'" class="w-6/12 py-2" label="Pontuação dessa questão" v-model="form.structure[index].points" v-maska="MaskService['numeric']" />
                                <BaseInput v-if="field.type === 'text' && form.type !== 'pdi'" class="flex-1" :model-value="'Campo de texto Curto'"  disabled="true" />
                                <BaseInput v-if="field.type === 'email'" class="flex-1" type="email" :model-value="'Campo de Email'"  disabled="true" />
								<div v-if="field.type === 'static_text'" class="flex flex-col gap-y-2">
									<p class="text-gray-600 text-sm font-medium">Este campo exibirá apenas o texto informado ao respondente.</p>
									<div class="border border-dashed border-gray-400 rounded-md p-3 text-gray-500 text-sm">
										Pré-visualização do texto
									</div>
								</div>
                                <BaseTextarea v-if="field.type === 'long_text'" rows="5" :model-value="'Campo de texto Longo'" disabled="true" />
                                <!-- Scale -->
                                <div v-if="field.type === 'scale'" class="flex flex-col gap-y-3">
                                    <div class="flex gap-x-4 items-end">
                                        <BaseInput type="number" label="De" class="w-24" v-model.number="field.from" @change="generateScaleOptions(index)" />
                                        <BaseInput type="number" label="Até" class="w-24" v-model.number="field.to" @change="generateScaleOptions(index)" />
                                    </div>
                                    <div v-if="field.options && field.options.length" class="flex flex-wrap gap-1 mt-1">
                                        <span v-for="opt in field.options" :key="opt.uuid" class="px-2 py-0.5 bg-green-100 text-green-700 rounded text-sm font-medium">{{ opt.label }}</span>
                                    </div>
                                </div>
                                <!-- Radio Button -->
                                <div class="flex flex-col gap-y-4" v-if="field.type === 'multiple_choice'">
                                    <div class="flex flex-col gap-x-2 mt-4" v-for="(option, indexRadio) in field.options" :key="option.uuid">
                                        <span class="text-gray-600 font-semibold text-sm mb-2 ml-6">Opção: {{ indexRadio + 1 }}</span>
                                        <div class="flex gap-x-2">
                                            <BaseRadio
                                                :name="field.uuid"
                                                disabled="true"
                                                />
                                            <div class="flex flex-1">
                                                <BaseInput v-if="!field.fixed && form.type !== 'pdi'" class="w-10/12" placeholder="Opção" v-model="field.options[indexRadio].label" />
												<span v-if="form.type === 'pdi'">{{ field.options[indexRadio].label }}</span>
                                                <svg v-if="!field.fixed && form.type !== 'pdi'" @click="addOption(index)" class="w-8 h-8 cursor-pointer text-green-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                                </svg>
                                                <svg v-if="!field.fixed && form.type !== 'pdi' && field.options.length > 1" @click="removeOption(index, indexRadio)" class="w-8 h-8 cursor-pointer text-red-400 hover:text-red-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                                    <path stroke-linecap="round" stroke-linejoin="round" d="M15 12H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- Checkbox-->
                                <div class="flex flex-col gap-y-4" v-if="field.type === 'checkbox'">
                                    <div class="flex flex-col gap-x-2 mt-4" v-for="(option, indexCheckbox) in field.options" :key="option.uuid">
                                        <span class="text-gray-600 font-semibold text-sm mb-2 ml-6">Opção: {{ indexCheckbox + 1 }}</span>
                                        <div class="flex gap-x-2">
                                            <BaseCheckbox disabled="true" />
                                            <div class="flex flex-1">
                                                <BaseInput class="w-10/12" placeholder="Opção" v-model="field.options[indexCheckbox].label" />
                                                <svg @click="addOption(index)" class="w-8 h-8 cursor-pointer text-green-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                                </svg>
                                                <svg v-if="field.options.length > 1" @click="removeOption(index, indexCheckbox)" class="w-8 h-8 cursor-pointer text-red-400 hover:text-red-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                                    <path stroke-linecap="round" stroke-linejoin="round" d="M15 12H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- SELECT-->
                                <div class="flex flex-col gap-y-4" v-if="field.type === 'select'">
                                    <div class="flex flex-col gap-x-2 mt-4" v-for="(option, indexSelect) in field.options" :key="option.uuid">
                                        <span class="text-gray-600 font-semibold text-sm mb-2 ml-6">Opção: {{ indexSelect + 1 }}</span>
                                        <div class="flex gap-x-2">
                                            <div class="flex flex-1">
                                                <BaseInput class="w-10/12" placeholder="Opção" v-model="field.options[indexSelect].label" />
                                                <svg @click="addOption(index)" class="w-8 h-8 cursor-pointer text-green-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" /></svg>
                                                <svg v-if="field.options.length > 1" @click="removeOption(index, indexSelect)" class="w-8 h-8 cursor-pointer text-red-400 hover:text-red-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M15 12H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" /></svg>
                                            </div>
                                        </div>
                                    </div>
                                    <BaseSelect
                                    label="Pré Visualização"
                                    :options="parseSelectOptions(field.options)"
                                    class="w-6/12"
                                    />
                                </div>
                            </div> <!-- Cabeçalho da Pergunta-->
                        </div>
                        
                        <BaseButton class="mt-8" @click="addQuestion()" skin="primary">Adicionar Campo</BaseButton>
                    </div>
                </div>

                <div v-if="form.uuid && !loadingFormRender && form.type" class="border-t-2 border-gray-400 mt-8 flex justify-end">
                    <BaseButton :disabled="loadingSubmit" class="mt-8" @click="submitForm()" skin="primary">
                        <svg v-if="loadingSubmit" class="animate-spin ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        {{ isEdit ? 'Atualizar': 'Salvar' }}
                    </BaseButton>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { ref, onMounted, watch, computed, onBeforeUnmount } from 'vue';
    import { useRoute, useRouter } from 'vue-router';
    import Alert from '@/components/Alert';
    import Tag from '@/components/Tag';
    import Swal from 'sweetalert';
    import { FormService } from '../services/Entity';
    import PaginationV2 from '@/components/PaginationV2';
    import UtilService from '../services/UtilService';
    import MaskService from '../services/MaskService';
    import { defaultDate } from '../filters/date';

    export default {
        name: 'Forms',
        components: {
            PaginationV2,
            Alert,
            Tag
        },
        setup() {
            const pageTitle = ref('Mega Forms');
            const isEdit = ref(false);
            const loadingFormList = ref(false);
            const loadingFormRender = ref(false);
            const loadingSubmit = ref(false);
            const totalItens = ref(0);
            const page = ref(1);
            const limit = ref(20);
            const form = ref({});
            const forms = ref([]);
            const selectedForm = ref({});
            const router = useRouter();
            const formTypeOptions = ref([
                { title: 'Avaliação 360', value: '360' },
				{ title: 'PDI', value: 'pdi' },
				{ title: 'Pesquisa de Clima', value: 'climate' },
				{ title: 'Padrão', value: 'default' },
				{ title: 'Confirmar Presença', value: 'presence' },
				{ title: 'Evento', value: 'event' },
            ]);
            const fieldTypeOptions = ref([
                { title: 'Texto Curto', value: 'text' },
                { title: 'Email', value: 'email' },
                { title: 'Só Texto', value: 'static_text' },
                { title: 'Texto Longo', value: 'long_text' },
                { title: 'Escala (De/Até)', value: 'scale' },
                { title: 'Múltipla Escolha', value: 'multiple_choice' },
                { title: 'Caixas de Seleção', value: 'checkbox' },
                { title: 'Seleção', value: 'select' },
            ]);
			const filterType = ref('all');
			const filterName = ref('');
			const filterTypeOptions = computed(() => ([
				{ title: 'Todos os tipos', value: 'all' },
				...(formTypeOptions.value || [])
			]));
			let filterNameTimeout = null;

            onMounted(async () => {
                await listForms();
            });

			watch(
				() => form.value?.structure?.map(q => q.points) ?? [],
				() => {
					if (form.value.type !== 'pdi') return;
					if (!form.value.structure) return;

					form.value.structure.forEach((field) => {
						const points = parseInt(field.points);

						if (field.type === 'multiple_choice' && !isNaN(points) && points > 0) {
							field.options = Array.from({ length: points + 1 }, (_, i) => ({
								uuid: UtilService.generateUUID(),
								label: i.toString(),
								answer: ''
							}));
						}

						if (isNaN(points) && field.type === 'multiple_choice') {
							field.options = [];
						}
					});
				},
				{ deep: true }
			);

			watch(filterType, async (newValue, oldValue) => {
				if (newValue === oldValue) return;
				page.value = 1;
				await listForms();
			});

			watch(filterName, (value) => {
				page.value = 1;
				if (filterNameTimeout) clearTimeout(filterNameTimeout);
				filterNameTimeout = setTimeout(() => {
					listForms();
					filterNameTimeout = null;
				}, 400);
			});

			onBeforeUnmount(() => {
				if (filterNameTimeout) {
					clearTimeout(filterNameTimeout);
					filterNameTimeout = null;
				}
			});

            function createForm() {
				resetForm();
                selectedForm.value = {};
                isEdit.value = false;
            }

			function getAllowedFieldTypes(formType) {
				const all = fieldTypeOptions.value || [];

				if (formType === 'pdi') {
					const allowed = ['multiple_choice', 'long_text'];
					return fieldTypeOptions.value.filter(f => allowed.includes(f.value));
				}

				if (formType === 'pdi') {
					const allowed = new Set(['multiple_choice', 'long_text']);
					return all.filter(f => allowed.has(f.value));
				}

				return all;
			}

            function resetForm() {
                form.value = {
                    uuid: UtilService.generateUUID(),
                    type: '',
                    structure: [
                        {
                            label: '',
                            score: 0,
                            lock: false,
                            presence_sync: false,
                            type: 'text',
                            uuid: '97c86a4a-9dad-483e-b091-f80b8143962d9'
                        },
                    ]
                }
            }

			async function listForms() {
				try {
					loadingFormList.value = true;
					const filters = {};
					const trimmedName = filterName.value?.trim();
					if (trimmedName) {
						filters.name = trimmedName;
					}
					if (filterType.value && filterType.value !== 'all') {
						filters.type = filterType.value;
					}
					const { data: { total, items } } = await FormService.list(page.value, limit.value, filters);

					totalItens.value = total;
					forms.value = items;
				} catch(err) {
					console.log(err);
					Swal({
						title: 'Ocorreu um erro',
						text: 'Atualize a página e tente novamente',
						icon: 'error'
					});
				} finally {
					loadingFormList.value = false;
				}

				return forms.value;
			}

            async function selectForm(formObj) {
                selectedForm.value = formObj;
                const retrivedForm = await getByUUID(formObj.uuid);
                form.value = { ...retrivedForm.form_body };

                if (form.value.type === 'event') {
                    ensureEventFixedFields();
                }

                isEdit.value = true;
            }

            async function getByUUID(uuid) {
                try {
                    loadingFormRender.value = true;
                    const { data } = await FormService.getById(uuid);
                    loadingFormRender.value = false;
                    
                    return data;
                } catch(err) {
                    loadingFormRender.value = false;
                    console.log(err);
                    Swal({
                        title: 'Ocorreu um erro',
                        text: 'Atualize a página e tente novamente',
                        icon: 'error'
                    });
                }
            }

            async function submitForm() {
                try {
                    const formObj = { ...form.value };

                    if (isEdit.value) {
                        await updateForm(formObj);
                    } else {
                        await saveForm(formObj);
                    }
                } catch(err) {
                    loadingSubmit.value = false;
                    console.log(err);
                    Swal({
                        title: 'Ocorreu um erro',
                        text: 'Atualize a página e tente novamente',
                        icon: 'error'
                    });
                }
            }

			async function saveForm(formObj) {
				try {
					if (!form.value.name) {
						Swal({
							title: 'Digite um nome para o formulário',
							icon: 'info'
						});
						return;
					}

					loadingSubmit.value = true;
					await FormService.create(formObj);
                    page.value = 1;
                    await listForms();
                    isEdit.value = true;
                    loadingSubmit.value = false;
                    Swal({
                        title: 'Salvo!',
                        icon: 'success'
                    });
                } catch(err) {
                    loadingSubmit.value = false;
                    console.log(err);
                    Swal({
                        title: 'Ocorreu um erro',
                        text: 'Atualize a página e tente novamente',
                        icon: 'error'
                    });
                }
            }

			async function updateForm(formObj) {
				try {
					loadingSubmit.value = true;
					await FormService.update(formObj);
					await listForms();

					Swal({
						title: 'Atualizado!',
						icon: 'success'
					});

                    loadingSubmit.value = false;
                } catch(err) {
                    loadingSubmit.value = false;
                    console.log(err);
                    Swal({
                        title: 'Ocorreu um erro',
                        text: 'Atualize a página e tente novamente',
                        icon: 'error'
                    });
                }
            }

            function cloneFieldOptions(options = []) {
                if (!Array.isArray(options)) return [];

                return options.map(option => ({
                    ...option,
                    uuid: UtilService.generateUUID()
                }));
            }

            function cloneFormStructure(structure = []) {
                if (!Array.isArray(structure)) return [];

                return structure.map(field => ({
                    ...field,
                    uuid: UtilService.generateUUID(),
                    options: cloneFieldOptions(field.options)
                }));
            }

            function cloneField(field = {}) {
                return {
                    ...field,
                    uuid: UtilService.generateUUID(),
                    options: cloneFieldOptions(field.options)
                };
            }

            function buildDuplicatedForm(sourceForm = {}) {
                return {
                    ...sourceForm,
                    uuid: UtilService.generateUUID(),
                    name: `${sourceForm.name || 'Formulário'} (Cópia)`,
                    structure: cloneFormStructure(sourceForm.structure),
                    score_result: sourceForm.score_result ? JSON.parse(JSON.stringify(sourceForm.score_result)) : sourceForm.score_result
                };
            }

            async function confirmDuplicateForm(formItem) {
                try {
                    const confirm = await Swal({
                        title: 'Deseja criar uma cópia deste formulário?',
                        text: 'Será criado um novo formulário com o nome original seguido de (Cópia).',
                        icon: 'warning',
                        buttons: {
                            cancel: 'Cancelar',
                            confirm: {
                                text: 'Sim, duplicar',
                                className: 'swal-button--info'
                            }
                        }
                    });

                    if (!confirm) return;

                    loadingFormList.value = true;

                    const originalForm = await getByUUID(formItem.uuid);
                    if (!originalForm?.form_body) {
                        throw new Error('original_form_not_found');
                    }

                    const duplicatedForm = buildDuplicatedForm(originalForm.form_body);
                    await FormService.create(duplicatedForm);

                    page.value = 1;
                    await listForms();

                    const createdForm = forms.value.find(item => item.uuid === duplicatedForm.uuid);
                    if (createdForm) {
                        await selectForm(createdForm);
                    }

                    Swal({
                        title: 'Cópia criada!',
                        icon: 'success'
                    });
                } catch (err) {
                    console.log(err);
                    Swal({
                        title: 'Ocorreu um erro',
                        text: 'Atualize a página e tente novamente',
                        icon: 'error'
                    });
                } finally {
                    loadingFormList.value = false;
                }
            }

            function escapeHtml(value = '') {
                return String(value ?? '')
                    .replace(/&/g, '&amp;')
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;')
                    .replace(/"/g, '&quot;')
                    .replace(/'/g, '&#39;');
            }

            async function destroyForm(uuid) {
                try {
                    const confirm = await Swal({
                        title: 'Tem certeza que deseja excluir esse formulário?',
                        text: 'Esta ação não pode ser desfeita',
                        icon: 'warning',
						buttons: {
							cancel: 'Cancelar',
							confirm: {
								text: 'Excluir',
								className: 'swal-button--danger'
							}
						},
						dangerMode: true
					});

					if (!confirm) return;

					loadingFormList.value = true;

					await FormService.destroy(uuid);
					await listForms();

					Swal({
						title: 'Excluído',
						icon: 'success'
					});

				} catch (err) {
					loadingSubmit.value = false;
					console.error('Erro ao excluir:', err);

					if (err?.data?.error === 'form_in_use') {
						Swal({
							title: 'Esse formulário está em uso',
							text: 'Uma empresa tem esse PDI em uso, altere para poder excluir',
							icon: 'warning'
						});
						return;
					}

					if (err?.data?.error === 'presence_form_in_use') {
						const pdis = Array.isArray(err?.data?.pdis) ? err.data.pdis : [];
						const content = document.createElement('div');
						content.className = 'text-left';
						if (pdis.length) {
							const listItems = pdis.map(pdi => {
								const company = pdi?.company?.name ? ` - ${escapeHtml(pdi.company.name)}` : '';
								const manager = pdi?.manager?.name ? `<div class="text-xs text-gray-600">Gestor: ${escapeHtml(pdi.manager.name)}</div>` : '';
								const target = pdi?.target?.name ? `<div class="text-xs text-gray-600">Liderado: ${escapeHtml(pdi.target.name)}</div>` : '';
								const competence = (pdi?.competence_month && pdi?.competence_year)
									? `<div class="text-xs text-gray-500">Competência: ${String(pdi.competence_month).padStart(2, '0')}/${escapeHtml(pdi.competence_year)}</div>`
									: '';
								const identifier = pdi?.uuid || pdi?.id;
								return `
									<li class="mb-2">
										<div class="font-semibold text-sm text-gray-700">PDI ${escapeHtml(identifier || '')}${company}</div>
										${manager}
										${target}
										${competence}
									</li>
								`;
							}).join('');
							content.innerHTML = `
								<p class="text-sm text-gray-700 mb-2">Este formulário de presença está vinculado aos seguintes PDIs:</p>
								<ul class="list-disc pl-5 text-sm text-gray-700">
									${listItems}
								</ul>
							`;
						} else {
							content.innerHTML = '<p class="text-sm text-gray-700">Este formulário de presença está vinculado a um PDI existente.</p>';
						}

						Swal({
							title: 'Formulário em uso',
							content,
							buttons: {
								cancel: 'Fechar',
								view: {
									text: 'Ver PDI',
									value: 'view',
									className: 'swal-button--info'
								}
							}
						}).then(result => {
							if (result === 'view') {
								router.push({ name: 'pdi' });
							}
						});
						return;
					}

					Swal({
						title: 'Ocorreu um erro',
						text: 'Atualize a página e tente novamente',
						icon: 'error'
					});
				} finally {
					loadingFormList.value = false;
				}
			}

            function onSelectFormType(type) {
				form.value.structure = [
					{
						label: '',
						score: 0,
						lock: false,
						presence_sync: false,
						type: 'text',
						uuid: '97c86a4a-9dad-483e-b091-f80b8143962d9'
					},
				]

				if (type === 'pdi') {
                    form.value.score_result = {
						excellent: {},
                        positive: { '>=': 8, "<": 11},
                        neutral: { '>=': 4, '<': 8 },
                        negative: { '<': 6 }
                    };

					const fixedQuestion = {
						label: 'Avaliação dos colaboradores - 360° (equipe e autoavaliação) ≥ 8',
						flag: '360',
						type: 'multiple_choice',
						uuid: UtilService.generateUUID(),
						fixed: true,
						required: true,
						lock: true,
						presence_sync: false,
						points: 1,
						options: [
							{
								uuid: UtilService.generateUUID(),
								label: '0',
								answer: ''
							},
							{
								uuid: UtilService.generateUUID(),
								label: '1',
								answer: ''
							}
						]
					};

					form.value.structure = [fixedQuestion];
                }

				if (type === '360') {
					form.value.structure.pop();

					const fixedQuestion = {
						label: "Na sua percepção FULANO(a), está alinhada a missão, visão e valores da empresa e tem demostrado esse alinhamento através de seus atos? Escolha uma nota de 1 a 10",
						score: 0,
						lock: false,
						type: "multiple_choice",
						uuid: "97c86a4a-9dad-483e-b091-f80b8143962d9",
						fixed: true,
						required: true,
						presence_sync: false,
						options: [
							{ uuid: "4f08dd10-6bbc-11f0-9bd9-995348129005", label: "1", answer: "" },
							{ uuid: "bc415fb0-6bbc-11f0-9bd9-995348129005", label: "2", answer: "" },
							{ uuid: "bc9e4cc0-6bbc-11f0-9bd9-995348129005", label: "3", answer: "" },
							{ uuid: "bd671b00-6bbc-11f0-9bd9-995348129005", label: "4", answer: "" },
							{ uuid: "bdb980c0-6bbc-11f0-9bd9-995348129005", label: "5", answer: "" },
							{ uuid: "bdfec720-6bbc-11f0-9bd9-995348129005", label: "6", answer: "" },
							{ uuid: "be41eaa0-6bbc-11f0-9bd9-995348129005", label: "7", answer: "" },
							{ uuid: "c2d15dd0-6bbc-11f0-9bd9-995348129005", label: "8", answer: "" },
							{ uuid: "c32486e0-6bbc-11f0-9bd9-995348129005", label: "9", answer: "" },
							{ uuid: "c45083c0-6bbc-11f0-9bd9-995348129005", label: "10", answer: "" }
						]
					};

					form.value.structure.unshift(fixedQuestion);
				}

				if (type === 'event') {
					ensureEventFixedFields();
				}
            }

            function ensureEventFixedFields() {
				if (!Array.isArray(form.value.structure)) {
					form.value.structure = [];
				}

				const hasName = form.value.structure.some(field => field.key === 'participant_name');
				const hasCpf = form.value.structure.some(field => field.key === 'participant_cpf');
				const hasEmail = form.value.structure.some(field => field.key === 'participant_email');
				const hasCompany = form.value.structure.some(field => field.key === 'participant_company');

				if (hasName && hasCpf && hasEmail && hasCompany) return;

				if (!hasEmail) {
					form.value.structure.unshift({
						uuid: UtilService.generateUUID(),
						label: 'Email',
						type: 'email',
						required: true,
						fixed: true,
						lock: false,
						key: 'participant_email'
					});
				}

				if (!hasCompany) {
					form.value.structure.unshift({
						uuid: UtilService.generateUUID(),
						label: 'Empresa',
						type: 'text',
						required: true,
						fixed: true,
						lock: false,
						key: 'participant_company'
					});
				}

				if (!hasCpf) {
					form.value.structure.unshift({
						uuid: UtilService.generateUUID(),
						label: 'CPF',
						type: 'text',
						data_type: 'cpf',
						required: true,
						fixed: true,
						lock: false,
						key: 'participant_cpf'
					});
				}

				if (!hasName) {
					form.value.structure.unshift({
						uuid: UtilService.generateUUID(),
						label: 'Nome completo',
						type: 'text',
						required: true,
						fixed: true,
						lock: false,
						key: 'participant_name'
					});
				}
            }

            function onChangeFieldType(index, type) {
                if (type === 'multiple_choice' || type === 'checkbox' || type === 'select') {
                    form.value.structure[index].options = [{ uuid: UtilService.generateUUID(), label: '', answer: '' }];
                    return;
                }

                if (type === 'scale') {
                    form.value.structure[index].from = 0;
                    form.value.structure[index].to = 10;
                    generateScaleOptions(index);
                    return;
                }

                if (type === 'static_text') {
                    form.value.structure[index].required = false;
                    form.value.structure[index].options = [];
                    form.value.structure[index].answer = '';
                    form.value.structure[index].presence_sync = false;
                }
            }

            function generateScaleOptions(fieldIndex) {
                const field = form.value.structure[fieldIndex];
                const from = parseInt(field.from);
                const to = parseInt(field.to);
                if (isNaN(from) || isNaN(to) || from > to || (to - from) > 999) return;
                field.options = Array.from({ length: to - from + 1 }, (_, i) => ({
                    uuid: UtilService.generateUUID(),
                    label: String(from + i),
                    answer: ''
                }));
            }

            function addOption(fieldIndex) {
                console.log(fieldIndex)
                form.value.structure[fieldIndex].options.push({ uuid: UtilService.generateUUID(), label: '', answer: '' });
            }

            function removeOption(fieldIndex, optionIndex) {
                const options = form.value.structure[fieldIndex].options;
                if (options.length <= 1) return;
                options.splice(optionIndex, 1);
            }

            function parseSelectOptions(options = []) {
                return options.map(opt => ({
                    title: opt.label,
                    value: opt.uuid
                }));
            }

            function addQuestion() {
                form.value.structure.push({
                    label: '',
                    score: 0,
                    lock: false,
                    presence_sync: false,
                    type: 'text',
                    uuid: UtilService.generateUUID()
                });
            }

            function duplicateQuestion(index) {
                const originalField = form.value.structure[index];
                if (!originalField) return;

                const duplicatedField = cloneField(originalField);
                form.value.structure = [
                    ...form.value.structure.slice(0, index + 1),
                    duplicatedField,
                    ...form.value.structure.slice(index + 1)
                ];
            }

            function moveFieldUp(index) {
                if (index <= 0) return;
                const temp = form.value.structure[index];
                form.value.structure.splice(index, 1);
                form.value.structure.splice(index - 1, 0, temp);
            }

            function moveFieldDown(index) {
                if (index >= form.value.structure.length - 1) return;
                const temp = form.value.structure[index];
                form.value.structure.splice(index, 1);
                form.value.structure.splice(index + 1, 0, temp);
            }

			async function changePagination(currentPage) {
				page.value = currentPage;
				await listForms();
			}

            function setFormForuse(uuid) {
                router.push({ name: 'send', params: { form_uuid: uuid } });
            }

            function preview(uuid) {
                const routeData = router.resolve({
                    name: 'surveyByForm',
                    params: { form_uuid: uuid }
                });
                
                window.open(routeData.href, '_blank');
            }

			async function deleteQuestion(uuid) {
				const confirm = await Swal({
					title: 'Deseja excluir esta pergunta?',
					text: 'Essa ação não pode ser desfeita.',
					icon: 'warning',
					buttons: {
						cancel: 'Cancelar',
						confirm: {
							text: 'Excluir',
							className: 'swal-button--danger'
						}
					},
					dangerMode: true
				});

				if (!confirm) return;

				const index = form.value.structure.findIndex(f => f.uuid === uuid);
				if (index !== -1) {
					form.value.structure.splice(index, 1);
				}

				await Swal({
					title: 'Pergunta excluída!',
					icon: 'success'
				});
			}

			return {
				deleteQuestion,
                duplicateQuestion,
                removeOption,
                generateScaleOptions,
				getAllowedFieldTypes,
                preview,
                setFormForuse,
				changePagination,
                confirmDuplicateForm,
                filterTypeOptions,
                filterType,
                filterName,
                selectedForm,
                addQuestion,
                parseSelectOptions,
                addOption,
                onChangeFieldType,
                fieldTypeOptions,
                moveFieldUp,
                moveFieldDown,
                onSelectFormType,
                createForm,
                resetForm,
                forms,
                form,
                totalItens,
                page,
                limit,
                selectForm,
                destroyForm,
                loadingSubmit,
                loadingFormRender,
                loadingFormList,
                pageTitle,
                isEdit,
                submitForm,
                formTypeOptions,
                MaskService,
                defaultDate
            }
        }
    }
</script>
